import styles from "../body.module.css";

const ListItem = ({ children }: { children: React.ReactNode }) => {
  if (!children) return null;
  return <li className={styles.listItem}>{children}</li>;
};

export default ListItem;
